import script from "./CourseList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseList.vue?vue&type=script&setup=true&lang=ts"

import "./CourseList.vue?vue&type=style&index=0&id=1576938a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1576938a"]])

export default __exports__